var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification",class:( _obj = {}, _obj['bg-' + _vm.notification.variant] = true, _obj )},[_c('span',[_vm._v(_vm._s(_vm.notification.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }